import angular from 'angular'

searchWizardController.$inject = ['$scope', '$window', 'configuration', 'search']
export default function searchWizardController($scope, $window, config, search) {
  $scope.userResults = []
  $scope.domainResults = []
  $scope.name = ''
  $scope.email = ''
  $scope.ssoExternalId = ''
  $scope.searchUsers = function(name, email, ssoExternalId) {
    search.searchUsers(name, email, ssoExternalId, 1000).then(
      function(data) {
        data = JSON.parse(data)
        console.dir(data)
        $scope.userResults = data.hits.hits
      },
      function(err) {
        console.log(err)
      }
    )
  }
  $scope.searchDomains = function(name) {
    search.searchDomains(name, 1000).then(
      function(data) {
        data = JSON.parse(data)
        console.dir(data)
        $scope.domainResults = data.hits.hits
      },
      function(err) {
        console.log(err)
      }
    )
  }
}
